export function getGroupedInvestmentBudgets({
	wallets,
	budgets,
	transactions,
}) {
	const byWalletType = (type) => wallets.filter((w) => w.type === type);

	const calcTransactionsSum = (walletId) =>
		transactions
			.filter(
				(t) =>
					t.walletId === walletId &&
					t.type === "investment-debt-payoff-auto",
			)
			.reduce(
				(sum, t) =>
					sum +
					(t.exchangeRate !== 1
						? t.amount * t.exchangeRate
						: t.amount),
				0,
			);

	return ["asset", "liability"].map((type) => {
		const walletsOfType = byWalletType(type);
		const budgetType = type === "asset" ? "investment" : "debtPayoff";

		const walletsWithBudgets = walletsOfType.map((wallet) => {
			const walletBudget = budgets.find((b) => b.walletId === wallet._id);

			return {
				walletId: wallet._id,
				name: wallet.name,
				currency: wallet.currency,
				budget: walletBudget?.amount || 0,
				budgetId: walletBudget?._id || "",
				budgetSource: walletBudget?.source || "",
				isBudgetRecurring: walletBudget?.recurring || false,
				transactionsSum: calcTransactionsSum(wallet._id),
			};
		});

		return {
			type: budgetType,
			totalBudget: walletsWithBudgets.reduce(
				(sum, w) => sum + w.budget,
				0,
			),
			totalTransactionsSum: walletsWithBudgets.reduce(
				(sum, w) => sum + w.transactionsSum,
				0,
			),
			wallets: walletsWithBudgets,
		};
	});
}
